import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CreateUsers} from './create-users.model';
import * as CreateUsersActions from './create-users.actions';

export const createUsersesFeatureKey = 'createUserses';

export interface State extends EntityState<CreateUsers> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CreateUsers> = createEntityAdapter<CreateUsers>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CreateUsersActions.addCreateUsers,
    (state, action) => adapter.addOne(action.createUsers, state)
  ),
  on(CreateUsersActions.upsertCreateUsers,
    (state, action) => adapter.upsertOne(action.createUsers, state)
  ),
  on(CreateUsersActions.addCreateUserss,
    (state, action) => adapter.addMany(action.createUserss, state)
  ),
  on(CreateUsersActions.upsertCreateUserss,
    (state, action) => adapter.upsertMany(action.createUserss, state)
  ),
  on(CreateUsersActions.updateCreateUsers,
    (state, action) => adapter.updateOne(action.createUsers, state)
  ),
  on(CreateUsersActions.updateCreateUserss,
    (state, action) => adapter.updateMany(action.createUserss, state)
  ),
  on(CreateUsersActions.deleteCreateUsers,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CreateUsersActions.deleteCreateUserss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CreateUsersActions.loadCreateUserss,
    (state, action) => adapter.setAll(action.createUserss, state)
  ),
  on(CreateUsersActions.clearCreateUserss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
